export interface IMinimizedDocumentMaterialProps {
    onDragEnd?: () => void;
    disabled?: boolean;
}

export const MIN_DOC_MATERIAL_DRAG_TYPE = 'MIN_DOC_MATERIAL_DRAG_TYPE';
